import { Box, Typography } from "@mui/material";
import {
    ResponsiveContainer,
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    CartesianGrid,
    LabelList,
    ReferenceArea
} from "recharts";

const data = [
    { year: 2008, value: 1.3 },
    { year: 2009, value: 2.1 },
    { year: 2010, value: 3.0 },
    { year: 2011, value: 2.9 },
    { year: 2012, value: 3.2 },
    { year: 2013, value: 3.3 },
    { year: 2014, value: 3.6 },
    { year: 2015, value: 4.3 },
    { year: 2016, value: 3.4 },
    { year: 2017, value: 2.7 },
    { year: 2018, value: 5.7 },
    { year: 2019, value: 4.9 },
    { year: 2020, value: 5.0 },
    { year: 2021, value: 5.0 },
    { year: 2022, value: 3.1 },
    { year: 2023, value: 0.2 },
    { year: 2024, value: 2.7 },
    { year: 2025, value: 1.6 },
];

const Tract3G2: React.FC = () => {
    return (
        <Box sx={{ position: "relative", height: 280 }}>
            {/* Graphique */}
            <ResponsiveContainer width="100%" height="100%">
                <BarChart
                    data={data}
                    margin={{ top: 40, right: 20, left: 20, bottom: 20 }}
                >
                    <CartesianGrid strokeDasharray="3 3" opacity={0.2} />
                    <XAxis dataKey="year" />
                    <YAxis domain={[0, 6]} />
                    <Tooltip formatter={(v) => `${v} M€`} />

                    {/* Zone du maire actuel */}
                    <ReferenceArea
                        x1={2018}
                        x2={2025}
                        fill="#e5e0ff"
                        fillOpacity={0.9}
                    />

                    {/* Barres trésorerie */}
                    <Bar dataKey="value" fill="#28313f" radius={[4, 4, 0, 0]}>
                        <LabelList
                            dataKey="value"
                            position="top"
                            formatter={(v) => String(v).replace(".", ",")}
                        />
                    </Bar>
                </BarChart>
            </ResponsiveContainer>

            {/* Libellé "M. Dintilhac maire" */}
            <Box
                sx={{
                    position: "absolute",
                    top: 8,
                    left: "60%",
                    px: 1,
                    py: 0.3,
                    bgcolor: "rgba(255,255,255,0.9)",
                    borderRadius: 1
                }}
            >
                <Typography
                    variant="caption"
                    sx={{ fontWeight: 600, fontStyle: "italic", color: "#444" }}
                >
                    M. Dintilhac maire
                </Typography>
            </Box>

            {/* Pastille -71% */}
            <Box
                sx={{
                    position: "absolute",
                    top: 32,
                    left: "72%",
                    px: 1.8,
                    py: 0.4,
                    bgcolor: "#b71c1c",
                    borderRadius: 999,
                    color: "#fff",
                    fontSize: 12,
                    fontWeight: 700
                }}
            >
                -71%
            </Box>

            {/* Pastille +166% (2008–2013) */}
            <Box
                sx={{
                    position: "absolute",
                    top: 32,
                    left: "20%",
                    px: 1.8,
                    py: 0.3,
                    bgcolor: "#fff",
                    borderRadius: 999,
                    border: "1px solid #555",
                    fontSize: 12,
                    fontWeight: 700,
                    color: "#444"
                }}
            >
                +166%
            </Box>

            {/* Pastille -25% (2014–2017) */}
            <Box
                sx={{
                    position: "absolute",
                    top: 52,
                    left: "45%",
                    px: 1.8,
                    py: 0.3,
                    bgcolor: "#fff",
                    borderRadius: 999,
                    border: "1px solid #555",
                    fontSize: 12,
                    fontWeight: 700,
                    color: "#444"
                }}
            >
                -25%
            </Box>
        </Box>
    );
};

export default Tract3G2;
